module.exports = __webpack_public_path__ + "img/dominika-b-ai.9671147f.webp";